import { useState, useSyncExternalStore } from "react";
import type { ImageImports } from "./image-imports";
export function ImageUploads({ imports }: { imports: ImageImports }) {
  const jobs = useSyncExternalStore(imports.subscribe, imports.getSnapshot);
  const [expanded, setExpanded] = useState(false);
  if (!jobs.length) return null;
  const failed = jobs.filter((j) => j.status === "Failed").length;
  return (
    <section
      className="image-uploads floating-surface"
      aria-label="Image uploads"
    >
      <button aria-expanded={expanded} onClick={() => setExpanded(!expanded)}>
        <span role="status">
          {failed
            ? `${failed} image${failed > 1 ? "s need" : " needs"} attention`
            : `Adding ${jobs.length} image${jobs.length > 1 ? "s" : ""}…`}
        </span>
        <span>{expanded ? "Hide" : "Details"}</span>
      </button>
      {(expanded || failed > 0) && (
        <ul>
          {jobs.map((job) => (
            <li key={job.id}>
              <span className="image-upload-name" title={job.name}>
                {job.name}
              </span>
              <small>{job.error || job.status}</small>
              {job.saved && (
                <small>
                  Saved on this device · resumes when this board reopens
                </small>
              )}
              {job.status === "Failed" && (
                <div>
                  {job.missingSource ? (
                    <label className="image-reselect">
                      Choose original
                      <input
                        aria-label={`Choose original for ${job.name}`}
                        type="file"
                        accept="image/png,image/jpeg,image/webp"
                        onChange={(event) => {
                          const file = event.target.files?.[0];
                          if (file) imports.reselect(job.id, file);
                        }}
                      />
                    </label>
                  ) : (
                    <button onClick={() => imports.retry(job.id)}>
                      {job.missingCard ? "Add image back" : "Retry"}
                    </button>
                  )}
                  <button
                    aria-label={`Forget upload for ${job.name}`}
                    onClick={() => imports.dismiss(job.id)}
                  >
                    Forget upload
                  </button>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
